import { makeStyles, Typography } from '@material-ui/core';
import { ReactComponent as Loader } from '../../assets/svg/cl-square-loader.svg';

interface Props {
  text?: string;
  spinnerOnly?: boolean;
}

export const Loading = (props: Props) => {
  const { text, spinnerOnly } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {/* <CircularProgress size={48} className={classes.progress} /> */}
      <div className={classes.loader}>
        <Loader />
      </div>
      {!spinnerOnly ? (
        <Typography className={classes.text} variant="subtitle1">
          {text ?? 'Loading...'}
        </Typography>
      ) : null}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    postition: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    height: '100%',
    margin: theme.spacing(2),
  },
  progress: {
    left: '50%',
    marginTop: -24,
    marginLeft: -24,
    position: 'relative',
    top: '50%',
  },
  text: {
    position: 'relative',
    textAlign: 'center',
  },
  loader: {
    display: 'flex',
    padding: 5,
    width: 70,
    height: 70,
  },
}));
